export default "__VITE_ASSET__DnI_DhFN__"